"use client";
import { useNavMenu } from "@/components/NavMenuContext";
import { PrismicNextLink } from "@prismicio/next";

const Default = ({ slice }) => {
  return (
    <div className="relative text-bleu">
      <PrismicNextLink
        field={slice.primary.link}
        prefetch={false}
        className="block cursor-pointer h4-n"
      />
    </div>
  );
};

const SubMenu = ({ slice, navIndex }) => {
  const { activeIndex } = useNavMenu();
  const isOpen = activeIndex === navIndex;

  return (
    <div className="relative block py-2">
      <div className="cursor-pointer rounded-lg px-4 py-2 h4-n transition-colors duration-300 hover:bg-light-beige">
        {slice.primary.label}
      </div>
      <div
        className={`fixed left-0 top-14 z-50 w-full overflow-visible p-3 transition-opacity duration-200 ${isOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"
          }`}
        inert={!isOpen}
        aria-hidden={!isOpen}>
        <div className="w-full overflow-visible pb-2">
          <div className="w-full rounded-lg bg-dark-beige p-4">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
              {slice.primary.group.map((item, index) => {
                return (
                  <div key={index} className="flex w-full flex-col gap-4">
                    <span className="text-lg font-bold text-dark-blue">{item.label}</span>
                    <ul className="flex w-full flex-col gap-2">
                      {item.links.map((link, linkIndex) => (
                        <li key={linkIndex}>
                          <PrismicNextLink
                            field={link}
                            prefetch={false}
                            className="text-sm transition-opacity duration-200 hover:opacity-70"
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
/**
 * @typedef {import("@prismicio/client").Content.MenuItemSlice} MenuItemSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<MenuItemSlice>} MenuItemProps
 * @type {import("react").FC<MenuItemProps>}
 */
const MenuItem = ({ slice, index: sliceIndex }) => {
  const { notifyEnter, notifyLeave } = useNavMenu();
  const index = sliceIndex ?? 0;

  return (
    <li
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      data-apx-ignore
      className="relative cursor-pointer overflow-visible"
      onMouseEnter={() => notifyEnter(index)}
      onMouseLeave={notifyLeave}
    >
      {slice.variation === "subMenu" ? (
        <SubMenu slice={slice} navIndex={index} />
      ) : (
        <Default slice={slice} />
      )}
    </li>
  );
};

export default MenuItem;
